import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import BookingDetailIndex from "../../../components/SidetabPages/Booking/BookingDetailIndex";

const BookingDetail = () => {
  return (
    <>
      <AnnouncementBar />
      <BookingDetailIndex />
    </>
  );
};
export default BookingDetail;
